<template>
  <hm-content title="商品列表">
    <div class="table-panel flex flex-between">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addGoods"
          >去进货</el-button
        >
      </div>
      <div class="flex-1 text-right">
        <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader>
        <el-cascader
          v-model="searchCondition.attributeId"
          placeholder="请选择辅助属性"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="attributeFunc"
          clearable
        ></el-cascader>
        <el-select
          v-model="searchCondition.depotId"
          placeholder="请选择仓库"
          size="small"
          filterable
          :disabled="!searchCondition.depotId"
          class="mr10"
        >
          <el-option
            :label="v.depotName"
            :value="v.depotId"
            v-for="(v, i) in depotList.records"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchCondition.platFormId"
          placeholder="请选择销售渠道"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.platformName"
            :value="v.platformId"
            v-for="(v, i) in salesChannels"
            :key="i"
          ></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入货号/条码/商品名/品牌"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(stockList, 'brandTable', '库存列表')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button type="info" size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div>
      <div class="flex  flex-between item-center">
        <div>
          <span>已选{{ num }}条</span>
        </div>
        <div class="flex batch flex-end item-center">
          <el-input
            size="small"
            type="text"
            v-model="stockQty"
            @input="filterGt0OrFixed2('stockQty')"
          ></el-input>
          <div @click="batchSetting">
            <span class="delete-icon hmicon icon-xitong"></span>
            批量设置
          </div>
        </div>
      </div>
      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="stockList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="sku名称">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.spuName }}</span>
              <span v-if="scope.row.specIdGroupName"
                >({{ scope.row.specIdGroupName }})</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="剩余库存">
          <template slot-scope="scope">
            <el-input
              size="small"
              @blur="changeStockQty(scope.row)"
              @input="filterInteger(scope.$index, scope.row.stockQty)"
              v-model="scope.row.stockQty"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="platFormName"
          label="销售渠道"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="toFlow(scope.row)"
              >库存流水</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="stockListTotal"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      title="进货列表"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <el-select
            clearable
            v-model="formSearchCondition.platFormId"
            placeholder="请选择销售平台"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              :label="v.platformName"
              :value="v.platformId"
              v-for="(v, i) in salesChannels"
              :key="i"
            ></el-option>
          </el-select>
          <el-cascader
            v-model="formSearchCondition.categoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择类目"
          ></el-cascader>
          <el-input
            clearable
            v-model.trim="formSearchCondition.keyWords"
            placeholder="请输入货号/商品名"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchPurchaseList"
            >查询</el-button
          >
        </div>
      </div>
      <div>
        <div class="mt10 flex flex-end mb20 item-center">
          <el-select
            clearable
            v-model="purchaseListPlatFormId"
            placeholder="请选择销售渠道"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              :label="v.platformName"
              :value="v.platformId"
              v-for="(v, i) in salesChannels"
              :key="i"
            ></el-option>
          </el-select>
          <el-input
            class="mr10"
            size="small"
            placeholder="请输入入库数量"
            v-model="purchaseListPlatFormIdStockQty"
            @input="filterGt0OrFixed2('purchaseListPlatFormIdStockQty')"
          ></el-input>
          <div @click="batchSettingPurchaseList">
            <span class="delete-icon hmicon icon-xitong"></span>
            批量设置
          </div>
        </div>
        <el-table
          stripe
          border
          ref="brandTable"
          @selection-change="getCheckedPurchaseList"
          :data="purchaseList"
          style="width: 100%"
          class="mb10"
          id="table"
          size="small"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="
              index =>
                index +
                (currentPurchaseListPage - 1) * currentPurchaseListPageSize +
                1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="SKU名称"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.spuName }}</span>
                <span v-if="scope.row.specIdGroupName"
                  >({{ scope.row.specIdGroupName }})</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="SKU货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="salesState"
            width="200px"
            label="销售渠道"
          >
            <template slot-scope="scope">
              <el-select
                clearable
                v-model="scope.row.platformId"
                placeholder="请选择销售渠道"
                size="small"
                filterable
                @change="setCurrentStockQty(scope.row)"
                class="mr10"
              >
                <el-option
                  :label="v.platformName"
                  :value="v.platformId"
                  v-for="(v, i) in salesChannels"
                  :key="i"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            width="200px"
            prop="salesState"
            label="入库数量"
          >
            <template slot-scope="scope">
              <el-input
                @change="setCurrentStockQty(scope.row)"
                @input="
                  filterIntegerByPurchase(scope.$index, scope.row.stockQty)
                "
                size="small"
                placeholder="请输入入库数量"
                v-model="scope.row.stockQty"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="purchaseListTotal"
          @current-change="purchaseListPaging"
          @size-change="handlePurchaseListSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPurchaseListPage"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  mixins: [outPutMixin],
  data() {
    return {
      tHeader: ["商品名称", "剩余库存", "销售渠道"],
      tBody: ["spuName", "stockQty", "platFormName"],
      stockQty: "",
      num: 0,
      checkedPurchaseListRow: [],
      purchaseListPlatFormId: "",
      purchaseListPlatFormIdStockQty: "",
      purchaseList: [],
      formSearchCondition: {},
      purchaseListTotal: 0,
      currentPurchaseListPage: 1,
      currentPurchaseListPageSize: 10,
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      stockList: [],
      stockListTotal: 0,
      platForm: "",
      stock: "",
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {
        depotId: ""
      },
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  async created() {
    this.getParamsCookie();
    await this.$store.dispatch("querySalesChannels");
    await this.$store.dispatch("queryDepotListList", {
      pageNo: 1,
      pageSize: 999999
    });
    await this.queryList();
  },
  computed: mapGetters([
    "depotList",
    "mallGoodsList",
    "salesChannels",
    "allMallGoodsList"
  ]),
  watch: {
    "depotList.records": {
      handler(val) {
        if (val.length) {
          this.searchCondition.depotId = val[0].depotId;
        }
      },
      deep: true
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(".", "").replace("-", "");
    },
    filterInteger(index, prop) {
      this.stockList[index].stockQty = prop.replace(".", "").replace("-", "");
    },
    filterIntegerByPurchase(index, prop) {
      this.purchaseList[index].stockQty = prop
        .replace(".", "")
        .replace("-", "");
    },
    async changeStockQty(row) {
      if (row.stockQty) {
        this.setStock([
          {
            depotSkuId: row.depotSkuId,
            stockQty: row.stockQty
          }
        ]);
      } else {
        this.$message({
          type: "warning",
          message: "请输入库存"
        });
      }
    },
    async setStock(params) {
      const { code } = await this.$store.dispatch("setCurrentStock", params);
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
      }
      if (params.length > 1) {
        if (this.dialogVisible) {
          this.queryPurchaseList();
        } else {
          this.queryList();
        }
      }
    },
    reset() {
      this.searchCondition = {};
      this.searchCondition.depotId = this.depotList.records[0].depotId;
    },
    async queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      const actionName = queryAll ? "queryAllStockList" : "queryStockList";
      const { result } = await this.$store.dispatch(actionName, params);
      const { records, total } = result;
      this.stockList = records;
      this.stockListTotal = total;
    },
    setParamsCookie() {
      setCookie({
        key: "stockInquiryParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "stockInquiryParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    toFlow(row) {
      this.$router.push({
        name: "StockFlow",
        query: {
          skuId: row.skuId,
          depotId: this.searchCondition.depotId
        }
      });
    },
    async addGoods() {
      this.dialogVisible = true;
      this.queryPurchaseList();
    },
    searchPurchaseList() {
      this.queryPurchaseList();
    },
    async queryPurchaseList() {
      const params = {
        pageSize: this.currentPurchaseListPageSize,
        pageNo: this.currentPurchaseListPage,
        depotId: this.searchCondition.depotId
      };
      const data = JSON.parse(JSON.stringify(this.formSearchCondition));
      if (data.categoryId) {
        data.categoryId = data.categoryId[0];
      }
      Object.assign(params, data);
      const { result } = await this.$store.dispatch(
        "queryPurchaseList",
        params
      );
      const { records, total } = result;
      this.purchaseList = records;
      this.purchaseListTotal = total;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    setCurrentStockQty(row) {
      if (row.platformId && row.stockQty) {
        this.setStock([
          {
            platformId: row.platformId,
            stockQty: row.stockQty,
            skuId: row.skuId,
            depotId: this.searchCondition.depotId
          }
        ]);
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    purchaseListPaging(page) {
      this.currentPurchaseListPage = page;
      this.queryPurchaseList();
    },
    handlePurchaseListSizeChange(size) {
      this.currentPurchaseListPage = 1;
      this.currentPurchaseListPageSize = size;
      this.queryPurchaseList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.num = selection.length;
    },
    getCheckedPurchaseList(selection) {
      this.checkedPurchaseListRow = selection;
    },
    batchSettingPurchaseList() {
      if (
        this.checkedPurchaseListRow.length &&
        this.purchaseListPlatFormIdStockQty &&
        this.purchaseListPlatFormId
      ) {
        this.checkedPurchaseListRow.forEach(v => {
          v.stockQty = this.purchaseListPlatFormIdStockQty;
          v.platformId = this.purchaseListPlatFormId;
          v.depotId = this.searchCondition.depotId;
        });
        this.setStock(this.checkedPurchaseListRow);
      } else {
        this.$message({
          message: "请选择商品并选择销售渠道并选择销售渠道和输入库存",
          type: "warning"
        });
      }
    },
    batchSetting() {
      if (this.checkedRow.length && this.stockQty) {
        this.checkedRow.forEach(v => {
          v.stockQty = this.stockQty;
        });
        this.setStock(this.checkedRow);
      } else {
        this.$message({
          message: "请选择商品并输入库存",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .tips {
    color: #666;
    font-size: 12px;
    padding-left: 10px;
  }
}
.tips {
  color: #999;
  font-size: 14px;
}
</style>
